import { useEffect, useState } from 'react';
import {
  ToggleInput,
  ButtonSecondary,
  ButtonSize,
  PermissionEnum,
} from '@ui/src';
import {
  TopUpVisibility,
  OrganizationType,
  CustomerStatus,
} from '../../../hoc/common/types';
import { TopUpOptionItemTypes } from './types';

import cn from './styles.module.css';

const TopUpOptionItem = ({
  topUpOption,
  setTopUpPanelIsOpen,
  customerType,
  setSelectedTopUpId,
  status,
  visibility: visibilityItem,
  topUpVisibilityIsLoading,
  activePermissions,
  selectedTopUpOptionId,
  setSelectedTopUpOptionId,
  addTopUpOptionVisibilityIsSuccess,
  updateTopUpOptionVisibilityIsSuccess,
  addVisibilityAction,
  updateVisibiliyAction,
}: TopUpOptionItemTypes) => {
  const [hover, setHover] = useState(false);
  const [checked, setChecked] = useState(false);
  const [visibility, setVisiblity] = useState<TopUpVisibility>();

  useEffect(() => {
    if (topUpOption && !topUpVisibilityIsLoading) {
      if (visibilityItem) {
        setVisiblity(visibilityItem);
        setChecked(visibilityItem.visible);
      } else {
        setChecked(topUpOption?.visibleToClients);
      }
    }
  }, [visibilityItem, topUpOption, topUpVisibilityIsLoading]);

  useEffect(() => {
    if (
      (addTopUpOptionVisibilityIsSuccess ||
        updateTopUpOptionVisibilityIsSuccess) &&
      selectedTopUpOptionId === visibility?.id
    ) {
      setSelectedTopUpOptionId('');
      setVisiblity(visibilityItem);
    }
  }, [
    addTopUpOptionVisibilityIsSuccess,
    selectedTopUpOptionId,
    visibility,
    visibilityItem,
    updateTopUpOptionVisibilityIsSuccess,
  ]);

  return (
    <div
      className={cn.topUpOptionItem}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div className={cn.topUpOptionItemBlock}>
        <div className={cn.topUpOptionItemBlockContent}>
          <ToggleInput
            name={`toggle-${topUpOption?.id}`}
            title=""
            disabled={
              !activePermissions?.includes(
                customerType === OrganizationType.INDIVIDUAL
                  ? PermissionEnum.INDIVIDUAL_CUSTOMERS_EDIT_TOPUP_ACTION
                  : PermissionEnum.CORPORATE_CUSTOMERS_EDIT_TOPUP_ACTION,
              ) || status === CustomerStatus.CLOSED
            }
            checked={checked}
            onChange={(e) => {
              setChecked(e.target.checked);

              if (!visibility) {
                addVisibilityAction(
                  e.target.checked,
                  topUpOption?.id as string,
                );
              } else {
                updateVisibiliyAction(
                  e.target.checked,
                  visibility?.id,
                  topUpOption?.id as string,
                  visibility?.pspPartnerId,
                );
              }
            }}
          />
          <div className={cn.topUpOptionValue}>{topUpOption?.companyName}</div>
        </div>
      </div>
      <div className={cn.topUpOptionItemBlock}>
        <div className={`${cn.topUpOptionItemBlockContent}  ${cn.topUpEnd}`}>
          {hover && (
            <ButtonSecondary
              className={`button-white ${cn.downloadButton}`}
              text=" Top-up Instruction"
              size={ButtonSize.SMALL}
              onClick={() => {
                setTopUpPanelIsOpen(true);
                setSelectedTopUpId(topUpOption?.id as string);
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default TopUpOptionItem;
